import { Component } from '@angular/core';
import { WARNING_UI } from 'src/app/constants/ui-strings';

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrl: './warning.component.scss'
})
export class WarningComponent {

  warning = WARNING_UI
}
